/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */

import React from 'react';

import { convertV1toV2Table } from 'reports/utils';

import ReportTableV2 from './ReportTableV2';

const ReportTable = ({ title, startDate, endDate, data, linkText, linkUrl, withBoldFooter }) => {
  const propsToPass = convertV1toV2Table(data);
  return <ReportTableV2 data={propsToPass} title={title} startDate={startDate} endDate={endDate} linkText={linkText} linkUrl={linkUrl} withBoldFooter={withBoldFooter} />;
};

export default ReportTable;
